export const FilesSection = {
  FilesSectionTitle: {},
  FilesSectionList: {
    margin: '- -Y',
  },
  flow: 'column',
  padding: '- - X2',
  gap: 'X2',
  ':hover': {
    '& header > button, & header > a': {
      opacity: 1,
    },
  },
};